import {createMuiTheme} from "@material-ui/core";

export default createMuiTheme({
        palette: {
            primary: {main: "#fff"},
            secondary: {main: "#000", light: "#c1d6d9"},
            text: {
                primary: "#71C8CD",
                secondary: "#DB9649",
                hint: "#E25843"
            }
        },
        shape: {
            borderRadius: 20
        },
        typography: {
            fontFamily: "Open Sans",
            button: {
                textTransform: "none"
            }
        },
        spacing: 5,
        overrides: {
            MuiInput: {
                underline: {
                    "&:after":  {
                        borderBottom: "1px solid #71C8CD"
                    }
                }
            }
        }
    }
);
